import { render, staticRenderFns } from "./ArticlesOverTime.vue?vue&type=template&id=09859d2b&scoped=true"
import script from "./ArticlesOverTime.vue?vue&type=script&lang=js"
export * from "./ArticlesOverTime.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOverTime.vue?vue&type=style&index=0&id=09859d2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09859d2b",
  null
  
)

export default component.exports